import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FieldErrorMessages } from '../field-error-messages/field-error-messages.component';

@Component({
  selector: 'ui-simple-select-field',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatTooltipModule,
    FieldErrorMessages,
  ],
  templateUrl: './simple-select-field.component.html',
  styleUrls: ['./simple-select-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleSelectFieldComponent<T> {
  @Input() fieldLabel: string;
  @Input() fieldControl: FormControl<T>;
  @Input() values: T[];
}
